import React, { useEffect, useState } from 'react'
import SubTitle from '../Components/SubTitle'
import { DayPicker ,getDefaultClassNames } from 'react-day-picker';
import "react-day-picker/style.css";
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import UpdateUserImage from '../redux/hooks/UpdateUserImage';
import { updateCurrentUser } from '../redux/slices/AuthSlice';
import Loading from './Loading';
import LoadingImage from '../Components/LoadingImage';
import UpdateUserProfile from '../redux/hooks/UpdateUserProfile';
import { setSuccessMessage } from '../redux/slices/MessageSlice';

const Profile = () => {
  const {currentUser}=useSelector((state)=>state.AuthReducer);
  const dispatch = useDispatch()
  const defaultClassNames = getDefaultClassNames();
  const titles=[{name:'حسابى',link:''}]
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);
  const {makeRequest, data, isLoading, error,success}=UpdateUserImage();
  const {makeRequestProfile, dataProfile, isLoadingProfile, errorProfile,successProfile}=UpdateUserProfile();
  console.log('isLoading',isLoading)
const { handleSubmit, register, formState, reset } =useForm();
const HandleSelect=(e)=>{
  console.log(e)
  setSelected(e)
  console.log('formState',formState)
  if(e)
  reset({'birthday':e.toLocaleDateString()})
  setOpen(false)
 }
const { errors } = formState;
if(successProfile){
  dispatch(setSuccessMessage('تم تعديل البيانات'));

}
const updateImage=(value)=>{
  dispatch(updateCurrentUser({image:value}))
}
const HandleImage=(event)=>{
  const file=event.target.files[0];
  if(file){
    makeRequest({image:file})
    
  }
 
}

useEffect(()=>{
  if(dataProfile){
    dispatch(updateCurrentUser(dataProfile.data))
  }
  console.log('currentUser',currentUser)
  reset(currentUser)
},[dataProfile])
useEffect(()=>{

  reset(currentUser)
},[currentUser])
useEffect(()=>{
  if(data){
    updateImage(data.data.image)
  }
},[data])
const onSubmit = (data) => {
    console.log("selectedFileselectedFile", data); 
    makeRequestProfile(data)
};

  return (
    <div>
        <div className='container mt-lg-5 py-5 mb-2'>
        <SubTitle titles={titles}/>  

        <div className=''>
           <div className='row'>
           
               <div className='col-lg-4 p-4'>
                  <div className='position-relative '>
                  <div className='right-profile d-none d-lg-flex flex-column gap-1'>
               
               <div className='d-flex  justify-content-center'>
                <input type='file' id="file" onChange={(e)=>HandleImage(e)} className='d-none'/>
                {currentUser?.image?(
                 <div className='position-relative'>
                  <img src={currentUser.image} className='profile-image'/>
                
                  <i class="fa-regular fa-circle-xmark xmark-image" onClick={()=>updateImage('')}></i>
                 </div>
                ):(
                  <label  htmlFor='file' className='d-flex position-relative flex-column gap-2 align-items-center profile-image'>
                  <i class="fa-regular fa-user"></i> 
                  <p>أختر صورتك</p>
                  {isLoading&&(
                    <LoadingImage/>  
                  )}
                 </label>
                )}
                   
                   
               </div>
               <div className='right-profile-list'>
                       <Link to="/">
                       <i class="fa-regular fa-circle-user"></i>
                       حسابى
                       </Link>
                       <Link to="/">
                       <i class="fa-solid fa-box"></i>
                       الطلبات
                       </Link>
                       <Link to="/">
                       <i class="fa-solid fa-arrow-right-from-bracket"></i>
                       تسجيل الخروج
                       </Link>
                    </div>
          </div>
                  </div>
               </div>
               <div className='col-lg-8'>
                <div>
                <div className='d-flex d-lg-none justify-content-center'>
                <input type='file' id="file" onChange={(e)=>HandleImage(e)} className='d-none'/>
                {currentUser?.image?(
                 <div className='position-relative'>
                  <img src={currentUser.image} className='profile-image'/>
                  <i class="fa-regular fa-circle-xmark xmark-image" onClick={()=>updateImage('')}></i>
                 </div>
                ):(
                  <label  htmlFor='file' className='d-flex position-relative flex-column gap-2 align-items-center profile-image'>
                  <i class="fa-regular fa-user"></i> 
                  <p>أختر صورتك</p>
                  {isLoading&&(
                    <LoadingImage/>  
                  )}
                 </label>
                )}
                   
                   
               </div>
                </div>
                   <form onSubmit={handleSubmit(onSubmit)} className='row profile-form gap-y-4 '>
                       <div className='col-md-6 d-flex flex-column  gap-2'>
                          <label htmlFor='f_name' className=''>الأسم الأول</label>
                          <input type='text' {...register("f_name",{
                            required: "الأسم الأول مطلوب",
            
                          })}  placeholder='ادخل الأسم الأول' id='f_name'/>
                           {errors.f_name&&<div className='text-danger'>{errors.f_name.message}</div>}
                       </div>
                       <div className='col-md-6 d-flex flex-column  gap-2'>
                          <label htmlFor='l_name'>الأسم الأخير</label>
                          <input type='text' {...register("l_name",{
                            required: "الأسم الأخير مطلوب",
            
                          })} placeholder='ادخل الأسم الأخير' id='l_name'/>
                           {errors.l_name&&<div className='text-danger'>{errors.l_name.message}</div>}
                       </div>
                       <div className='col-md-6 d-flex flex-column  gap-2' style={{ position:'relative' }}>
                          <label htmlFor='birthday' className=''>تاريخ الميلاد </label>
                          <input type='text'
                          {...register("birthday",{
                            required: "تاريخ الميلاد مطلوب",
                          })}
                         
                          onChange={(e)=>{
                            console.log('e.target.value',e.target.value);
                            
                           
                          }}
                          placeholder='ادخل تاريخ الميلاد' 
                          
                          style={{ position:'relative' }} id='f_name' 
                          onClick={()=>setOpen(!open)}
                          />
                           {errors.birthday&&<div className='text-danger'>{errors.birthday.message}</div>}
                           <div style={{ 
                             display:open?'block':'none',position:'absolute',top:'105px',borderRadius:'10px',boxShadow:'1px 2px 10px gray'
                            }}>
                            <DayPicker
                            mode="single"
                            captionLayout="dropdown"
                            
                            selected={selected}
                            onSelect={(e)=>HandleSelect(e)}
                            style={{ direction:'ltr'}}    
                            classNames={{
                                today: `my-calendar-today border-amber-500`, // Add a border to today's date
                                selected: ` my-calendar-selected `, 
                                root: `${defaultClassNames.root} my-calendar  `, // Add a shadow to the root element
                                chevron: `  my-calendar-chevron`,
                               years_dropdown:'my-calendar-years_dropdown',
                               button_next:'  button_next  d-none',
                              
                               month_caption:'bg-white p-3 rounded ',
                               button_previous:'  button_previous d-none ',
                               day:'my-calendar-day',
                               week_number:'my-calendar-week_number',
                               day_button:` day_button`
                              }}
                            
                            />
                           </div>
                          </div>
                          <div className='col-md-6 d-flex flex-column  gap-2'>
                          <label htmlFor='sex'>الجنس

                          </label>

                             <select name="sex" id="sex" 
                             {...register("sex",{
                              required: "الجنس مطلوب",
                            })}
                             >
                              <option value="">حدد نوع الجنس</option>
                              <option value="male">ذكر</option>
                              <option value="female">أنثى</option>
                            </select>
                            {errors.sex&&<div className='text-danger'>{errors.sex.message}</div>}
                       </div>
                       <div className='col-md-6 d-flex flex-column  gap-2'>
                          <label htmlFor='email' className=''>البريد الإلكترونى</label>
                          <input type='text'  disabled
                          {...register("email", {
                            required: "البريد الإلكترونى مطلوب",
                            validate: {
                              matchPattern: (v) =>
                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                                "دخل بريد إلكترونى",
                            },
                          })}
                          placeholder='ادخل البريد الإلكترونى' id='email'/>
                          {errors.email&&<div className='text-danger'>{errors.email.message}</div>}
                       </div>

                       <div className='col-md-6 d-flex flex-column  gap-2'>
                       <label for="phone">رقم التلفون </label>
                        <input type='text'
                          {...register("phone",{
                            required: "رقم التلفون مطلوب",
                            validate: {
                              matchPattern: (v) =>
                                /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{4}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v)||
                                  "ادخل رقم تلفون صحيح"
                                },
                          
                          })}
                         placeholder=' ادخل رقم التلفون' id="phone"  className='city' />
                        {errors.phone&&<div className='text-danger'>{errors.phone.message}</div>}
                       </div>
                       <div className='col-md-12 d-flex flex-column  gap-2'>
                        {isLoadingProfile?(
                          <button  disabled={true}   id='email'>
                               Loading ...
                          </button>

                        ):(
                          <input type='submit'   value="حفظ" id='email'/>
                        )}
                       </div>
                   </form>
               </div>
           </div>
        </div>
        </div>   
    </div>
  )
}

export default Profile